import { ConfigProvider, Table, theme } from 'antd'
import Title from 'antd/lib/typography/Title'
import { FC } from 'react'
import { MANAGER_SUMMARY_LABELS } from '../constants/manager-summary-labels'
import { ManagerShipmentRow } from '../helpers/calc-manager-monthly-stats'
import { columns } from './columns'

interface ShipmentsTableProps {
    rows: ManagerShipmentRow[]
    isLoading: boolean
}

const ShipmentsTable: FC<ShipmentsTableProps> = ({ rows, isLoading }) => {
    return (
        <ConfigProvider theme={{ algorithm: theme.compactAlgorithm }}>
            <Table
                title={() => (
                    <Title style={{ marginTop: 0 }} level={5}>
                        {MANAGER_SUMMARY_LABELS.shipments}
                    </Title>
                )}
                columns={columns}
                dataSource={rows}
                rowKey='key'
                size='small'
                pagination={false}
                loading={isLoading}
            />
        </ConfigProvider>
    )
}

export default ShipmentsTable
